import React from 'react';
import styled from 'styled-components';
import {proto,url} from '../../Helpers/api';
import Tabela, {TabelaLinha as TL} from '../../Common/Tabela';
import Celula from '../../Common/Celula';
import { MesExtenso } from '../../Helpers/date';
import MoreInfo from './index';

const TabelaLinha = styled(TL)`
  grid-template-columns: 280px;
`

export default function MIEmprFolha (props) {
  const { dados={} } = props;
  const { empresa, mes, ano } = dados;
  return (
    <MoreInfo
      titulo={empresa}        
      subtitulo={`Lista de Empregados em Folha (${MesExtenso(dados.mes-1)}/${dados.ano})`}
      f={{
        url: `${proto}://${url}/main/metricas/pessoal/folha`,
        opt: {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ empresa, mes, ano })
        },
      }}
      modalData={dados}
    >
    {(data) => data && (
      <Tabela>
        <TabelaLinha header>
          <Celula>Nome</Celula>
        </TabelaLinha>
        {data.map(e => {
          return (
            <TabelaLinha>
              <Celula>{e.nome}</Celula>
            </TabelaLinha>
          )
        })}
      </Tabela>
    )}
    </MoreInfo>
  )
}
